import {Deserializable} from '../deserializable';
import {MeetingFile} from './meetingfile';
import {VanBanPhapQuyFile} from './vanbanphapquyfile';


export  class VanBanPhapQuy implements Deserializable {
  public id: number;
  public soHieuGoc: string;
  public ngayVaoSo: string;
  public ngayKy: string;
  public trichYeu: string;
  public noiGui: string;
  public usersRead: string;
  public soLuotDoc: number;
  public dViDuocDoc: string;
  public maLoaiVB: number;
  public nguoiKy: string;
  public nguoiVaoSoID: number;
  public soVanThuID: number;
  public vanBanPhapQuyFiles: VanBanPhapQuyFile[];
  deserialize(input: any): this {
    Object.assign(this, input);
    this.vanBanPhapQuyFiles = input.vanBanPhapQuyFiles.map(vanBanPhapQuyFiles => new VanBanPhapQuyFile().deserialize(vanBanPhapQuyFiles));
    return this;
  }
}
